import { supabase } from '@/integrations/supabase/client';
import { getAdSessionId } from './adSession';
import { detectVisitorCity, getCachedVisitorCity } from './visitorCity';

const recentImpressions = new Set<string>();

/**
 * Log an impression or click for an actively-boosted listing.
 * The server-side RPC resolves the active featured_listings row, the tier,
 * and the originating package — so callers only pass listing identifiers.
 * Returns null when the listing is not currently boosted (no analytics row created).
 */
export async function logFeaturedListingEvent(
  listingId: string,
  listingType: 'property' | 'plot' | 'project' | 'commercial',
  eventType: 'impression' | 'click',
  page?: string
) {
  if (!listingId || !listingType) return;

  // De-dupe impressions in-session to avoid double counting on re-renders
  if (eventType === 'impression') {
    const key = `${listingId}:${listingType}`;
    if (recentImpressions.has(key)) return;
    recentImpressions.add(key);
  }

  try {
    const city = (getCachedVisitorCity() || (await detectVisitorCity().catch(() => ''))) || null;
    await supabase.rpc('log_featured_listing_event', {
      _listing_id: listingId,
      _listing_type: listingType,
      _event_type: eventType,
      _session_id: getAdSessionId(),
      _city: city,
      _page: page || (typeof window !== 'undefined' ? window.location.pathname : null),
      _referrer: typeof document !== 'undefined' ? document.referrer : null,
    });
  } catch (err) {
    // Analytics must never break the UI
    console.warn('[featuredAnalytics] log failed', err);
  }
}
